import React, { useState } from "react";
import { Col, Row } from "reactstrap";
import { updateUserAttributes } from "components/shared/mailchimp";

const PlayerSound = ({
  audio_url,
  audioData = [],
  handleIsLoading,
  handleSetCurrentUser
}) => {
  const [audio, setAudio] = useState(null);

  const playSound = async (url) => {
    handleIsLoading(true);
    if (audio && !audio.paused) {
      audio.pause();
      audio.currentTime = 0;
    }
    const newAudio = new Audio(url);
    newAudio.play();
    setAudio(newAudio);

    await updateUserAttributes({ "custom:audioEffect": url }, (res, err) => {
      if (res === "SUCCESS") {
        handleSetCurrentUser("audio_url", url);
      }
    });
    handleIsLoading(false);
  };

  return (
    <div className="player-sound">
      <h2>Select Player Sound</h2>
      <p>Customize the noise you make in team activities. Have fun with it!</p>
      <Row>
        {audioData.map((item) => (
          <Col key={item.sound_url} md={6} lg={3}>
            <div
              className={`sound-card ${
                item.sound_url === audio_url ? "active" : ""
              }`}
              onClick={() => playSound(item.sound_url)}
            >
              <img src={item.sound_image_url} className="img-fluid" alt="two" />
              <p className="name">{item.sound_label}</p>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default PlayerSound;
